import React from 'react';
import { useAtomValue as useStateSegmentValue } from 'jotai';
import styles from './NavSection.module.css';
import NavMenuItem from '../../atoms/NavMenuItem';
import { translate } from '../../../localization';
import { contentParamsSegment } from '../../../store/markettingContentGeneration/stateSegments/paramsSegment';
import { GENERATE_CLAIMS } from '../../../constants/common';

interface NavSectionItem {
  icon: React.ReactNode;
  text: string;
  name: string;
  tooltip: string;
}

interface NavSectionProps {
  items: NavSectionItem[];
  isExpanded: boolean;
  onNavMenuClicked: (name: string) => void;
  className?: string;
  activeMenu?: string;
}

const NavSection: React.FC<NavSectionProps> = ({
  items,
  isExpanded,
  onNavMenuClicked,
  className,
  activeMenu = '',
}) => {
  const paramsSegmentValue = useStateSegmentValue(contentParamsSegment);

  return (
    <div className={`${styles['nav-section']} ${className}`}>
      <ul className={styles['menu-list']} role='menu'>
        {items.map(item => (
          <NavMenuItem
            key={item.name}
            icon={item.icon}
            name={item.name}
            text={item.text}
            tooltip={item.tooltip}
            isExpanded={isExpanded}
            isActive={activeMenu === item.name}
            isDisabled={
              paramsSegmentValue?.currentSelectedAction?.toLowerCase() ===
              GENERATE_CLAIMS.toLowerCase()
            }
            handleMenuItemClick={() => onNavMenuClicked(item.name)}
            isBetaFeature={
              item?.text?.toLowerCase() === translate('upload').toLowerCase()
            } // Needs to be passed till "Upload" is a beta feature
          />
        ))}
      </ul>
    </div>
  );
};

export default NavSection;
